module.exports = __webpack_public_path__ + "img/enterpriseTrainingBg.211b8fa2.png";